import { FileInterface } from "./interfaces/FileInterface";

export class AppercodeFile implements FileInterface {
    id?: string;
    length = undefined;
    name = '';
    isFile = true;
    parentId = undefined;
    ownerId = undefined;
    fileType = undefined;
    shareStatus = undefined;
    shareStatusTotal = undefined;
    rights = {};
    properties = undefined;
    createdAt = undefined;
    updatedAt = undefined;
    isDeleted = false;
    contentType? = undefined;

    constructor(data: FileInterface) {
        Object.assign(this, data);
    }
}
